module.exports = __webpack_public_path__ + "img/intact.2c626e3e.svg";